import { Routes } from '@angular/router';
import { AuthSsoGuard } from '@core/guards/auth-sso.guard';
import { flagGuard } from '@core/guards/flag.guard';
import { FunctionalPermissionGuard } from '@core/guards/functional-permission.guard';
import { UserPermissionGuard } from '@core/guards/user-permission.guard';

const appRoutes = [
  {
    path: 'my-electric-vehicles',
    canActivate: [AuthSsoGuard, FunctionalPermissionGuard, UserPermissionGuard],
    data: {
      requiredFunctionalPermission: ['ViewChargingDashboard'],
      requiredUserPermissions: ['ViewChargingDashboard'],
      redirectUrl: '/overview',
    },
    pathMatch: 'prefix',
    loadChildren: () => import('@pages/my-electric-vehicles/my-electric-vehicles-routes'),
  },
  {
    path: 'charging-management',
    pathMatch: 'prefix',
    canActivate: [
      AuthSsoGuard,
      flagGuard('ViewPublicCharging', '/notallowed'),
      UserPermissionGuard,
      FunctionalPermissionGuard,
    ],
    data: {
      requiredFunctionalPermission: [],
      requiredUserPermissions: ['ViewPublicCharging'],
      redirectUrl: '/notallowed',
    },
    loadChildren: () => import('@pages/charging-management/charging-management-routes'),
  },
  {
    path: 'onboarding',
    canActivate: [AuthSsoGuard, flagGuard('ViewPublicCharging', '/charging-management')],
    data: {
      requiredFunctionalPermission: [],
      requiredUserPermissions: ['ViewPublicCharging'],
      redirectUrl: '/charging-management',
    },
    pathMatch: 'prefix',
    loadChildren: () => import('@pages/charging-management/onboarding/onboarding.routes'),
  },

  {
    path: 'departure-scheduling',
    canActivate: [AuthSsoGuard, FunctionalPermissionGuard, UserPermissionGuard],
    data: {
      requiredFunctionalPermission: ['ViewChargingDashboard', 'ShowDepartureSchedulingPage'],
      requiredUserPermissions: ['ViewDepartureScheduling'],
      redirectUrl: '/notallowed',
    },
    pathMatch: 'full',
    loadComponent: () =>
      import('@pages/departure-scheduling/components/departure-scheduling/departure-scheduling.component'),
  },
  {
    path: 'settings',
    canActivate: [AuthSsoGuard, FunctionalPermissionGuard, UserPermissionGuard],
    data: {
      requiredFunctionalPermission: ['ViewChargingDashboard'],
      requiredUserPermissions: ['ViewChargingSettings'],
      redirectUrl: '/notallowed',
    },
    pathMatch: 'full',
    loadComponent: () => import('@pages/charging-settings/components/charging-notifications-settings.component'),
  },
  {
    path: 'charging-sessions',
    canActivate: [AuthSsoGuard, FunctionalPermissionGuard],
    pathMatch: 'prefix',
    data: {
      requiredFunctionalPermission: ['ViewChargingDashboard'],
      redirectUrl: '/notallowed',
    },
    loadChildren: () => import('@pages/real-time-monitoring-charging-sessions/rtm-charging-sessions-routes'),
  },
  {
    path: 'certificate-settings',
    canActivate: [AuthSsoGuard, flagGuard('ViewVasBlack', '/notallowed')],
    pathMatch: 'prefix',
    loadChildren: () => import('@pages/certificate-settings/certificate-settings-routes'),
  },
  {
    path: 'admin',
    canActivate: [AuthSsoGuard, flagGuard('Admin', '/notallowed')],
    pathMatch: 'full',
    loadComponent: () => import('@pages/developer/developer.component'),
  },
  {
    path: 'map',
    canActivate: [AuthSsoGuard, flagGuard('ViewMap', '/notallowed')],
    pathMatch: 'full',
    loadChildren: () => import('@pages/map/map-routes'),
  },
  {
    path: 'overview',
    canActivate: [AuthSsoGuard],
    loadComponent: () => import('@shared/components/overview/overview.component'),
  },
  {
    path: 'notallowed',
    canActivate: [AuthSsoGuard],
    loadComponent: () => import('@shared/components/not-allowed-page/not-allowed-page.component'),
  },
  {
    path: '',
    redirectTo: 'my-electric-vehicles',
    pathMatch: 'prefix',
  },
  {
    path: '*',
    canActivate: [AuthSsoGuard],
    loadComponent: () => import('@shared/components/overview/overview.component'),
  },
  {
    path: '**',
    redirectTo: 'pageNotFound',
  },
  {
    path: 'pageNotFound',
    canActivate: [AuthSsoGuard],
    loadComponent: () => import('@shared/components/page-not-found/page-not-found.component'),
  },
] satisfies Routes;

export default appRoutes;
